<template>
    <section class="d-flex">
        <div class="row g-0 overflow-hidden w-100 ">
            <div class="col-lg-5 col-md-12 col-sm-12 signup-image">
                <div class="image"></div>
            </div>
            <div class="col-lg-7 col-md-12 col-sm-12 container-3">
                <div class="mx-auto">
                    <div class="d-flex flex-column content-login align-items-flex-start px-5 mx-5"
                        style="margin-bottom: 50px;">
                        <div class="info">
                            <div class="mb-5">
                                <router-link to="/">
                                    <img src="../../assets/images/home/sign-up-logo.svg" alt="" class="img-fluid">
                                </router-link>
                            </div>
                            <!----<h3 class="text text-capitalize">
                                Welcome to Planning Force
                            </h3>-->
                        </div>
                    </div>
                    <form id="formAuthentication" class="mx-5" @submit.prevent="submitLogin" novalidate>
                        <!----------Email------------------------>
                        <div class="row">
                            <div class="col mb-24">
                                <span class="text-capitalize">Email</span>
                                <div class="form-control position-relative">
                                    <input type="text" :placeholder="$t('form.emaillogin')" aria-label="email"
                                        v-model="userEmail" class="w-100 svg-fill">
                                    <label class="user-first">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17"
                                            viewBox="0 0 18 17" fill="none">
                                            <g clip-path="url(#clip0_1398_5610)">
                                                <path
                                                    d="M1.49755 2.67651H15.5419C16.3677 2.67651 17.0396 3.34679 17.0396 4.17065V12.8294C17.0396 13.6533 16.3677 14.3236 15.5419 14.3236H1.49755C0.671758 14.3236 -7.62939e-05 13.6533 -7.62939e-05 12.8294V4.17065C-7.62939e-05 3.34679 0.671758 2.67651 1.49755 2.67651ZM1.693 3.67261L1.89289 3.83866L7.92555 8.85037C8.26987 9.13638 8.76967 9.13638 9.11393 8.85037L15.1466 3.83866L15.3465 3.67261H1.693ZM16.0411 4.39172L11.1259 8.47514L16.0411 11.7388V4.39172ZM1.49755 13.3275H15.5419C15.7831 13.3275 15.9849 13.1559 16.0311 12.9287L10.3253 9.14017L9.75278 9.61583C9.39555 9.9126 8.95761 10.061 8.5197 10.061C8.0818 10.061 7.64389 9.9126 7.28663 9.61583L6.71407 9.14017L1.00832 12.9286C1.05458 13.1559 1.25633 13.3275 1.49755 13.3275ZM0.998339 11.7388L5.91361 8.47517L0.998339 4.39172V11.7388Z"
                                                    fill="#0F1030" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1398_5610">
                                                    <rect width="17.0396" height="17" fill="white"
                                                        transform="matrix(-1 0 0 1 17.0396 0)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </label>
                                </div>
                                <span class="errorMessage text-danger" v-if="v$.userEmail.$error">
                                    {{ v$.userEmail.$errors[0].$message }}
                                </span>
                            </div>
                        </div>

                        <!-----------Start Of Pass---------------------------->
                        <div class="row mb-24">
                            <div class="col">
                                <span class="text-capitalize">Password</span>
                                <div class="form-control position-relative">
                                    <input :type="showPasswordValue ? 'password' : 'text'" v-model="password"
                                        :placeholder="$t('form.enterPassword')" aria-label="full name" class="w-100">
                                    <label class="user-first">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18"
                                            viewBox="0 0 17 18" fill="none">
                                            <g clip-path="url(#clip0_1392_23741)">
                                                <path
                                                    d="M13.0033 7.7296V5.03742C13.0105 3.81927 12.524 2.64798 11.6554 1.79383C10.8157 0.957706 9.7165 0.5 8.55242 0.5C8.5344 0.5 8.51277 0.5 8.49475 0.5C6.01161 0.503604 3.99338 2.53625 3.99338 5.03742V7.7296C3.05634 7.84132 2.37158 8.62699 2.37158 9.57844V15.6259C2.37158 16.6531 3.19329 17.5 4.22043 17.5H12.7799C13.807 17.5 14.6287 16.6531 14.6287 15.6259V9.57844C14.6251 8.63059 13.9404 7.84132 13.0033 7.7296ZM4.71057 5.03742H4.71417C4.71417 2.93269 6.41165 1.20999 8.49836 1.20999H8.50196C9.49306 1.20638 10.4445 1.59922 11.1473 2.29839C11.8789 3.02279 12.2861 4.01028 12.2789 5.03742V7.7332H11.4861V5.03742C11.4933 4.21931 11.1689 3.43364 10.5887 2.85701C10.0409 2.3092 9.29844 1.99926 8.52359 1.99926H8.50196C6.84413 1.99926 5.50345 3.36156 5.50345 5.03381V7.7332H4.71057V5.03742ZM10.7689 5.03742V7.7332H6.22785V5.03742C6.22785 3.76161 7.24417 2.72366 8.50557 2.72366H8.52719C9.11104 2.72366 9.67326 2.95792 10.0877 3.37238C10.5274 3.81206 10.7761 4.41393 10.7689 5.03742ZM13.9404 15.6367C13.9404 16.2674 13.4286 16.7792 12.7979 16.7792H4.23484C3.60414 16.7792 3.09238 16.2674 3.09238 15.6367V9.59646C3.09238 8.96576 3.60414 8.454 4.23484 8.454H12.7979C13.4286 8.454 13.9404 8.96576 13.9404 9.59646V15.6367Z"
                                                    fill="#0F1030" />
                                                <path
                                                    d="M9.74528 12.3933C9.58671 11.8347 9.07855 11.4526 8.49831 11.4526C7.78111 11.4526 7.19727 12.0329 7.19727 12.7537C7.19727 13.3339 7.57929 13.8421 8.13791 14.0007V15.0098C8.13791 15.208 8.30009 15.3702 8.49831 15.3702C8.69652 15.3702 8.8587 15.208 8.8587 15.0098V14.0007C9.54707 13.8024 9.94711 13.0816 9.74528 12.3933ZM8.49831 13.3303C8.17755 13.3303 7.91806 13.0708 7.91806 12.7501C7.91806 12.4293 8.17755 12.1698 8.49831 12.1698C8.81906 12.1698 9.07855 12.4293 9.07855 12.7501C9.07855 13.0708 8.81906 13.3303 8.49831 13.3303Z"
                                                    fill="#0F1030" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1392_23741">
                                                    <rect width="17" height="17" fill="white"
                                                        transform="translate(0 0.5)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </label>
                                    <span class="input-group-text-fa cursor-pointer">
                                        <span v-if="!showPasswordValue" @click="showPassword">
                                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                                viewBox="0 0 24 24">
                                                <path stroke="currentColor" stroke-linecap="round"
                                                    stroke-linejoin="round" stroke-width="2"
                                                    d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>

                                        </span>

                                        <span v-if="showPasswordValue" @click="hidePassword">
                                            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                                viewBox="0 0 24 24">
                                                <path stroke="#ABABAB" stroke-width="2"
                                                    d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z" />
                                                <path stroke="#ABABAB" stroke-width="2"
                                                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                            </svg>
                                        </span>

                                    </span>
                                </div>
                                <span class="errorMessage text-danger " v-if="v$.password.$error">
                                    {{ v$.password.$errors[0].$message }}
                                </span>
                            </div>
                            <div class="d-flex justify-content-end mt-4">
                               <a href="https://learn.planning-force.com/forgot-password" target="_blank" class="forget-pass"> {{ $t('forgetPass') }} </a>
                            </div>
                        </div>
                        
                        <!--------End Of Pass-------------->
                        <div class="alert alert-danger mb-3" v-if="serverError">
                            {{ serverError }}
                        </div>
                        <!---------------------------->
                        <button class="main-button d-grid w-100 mb-24  fw-500" type="submit">
                            {{ $t('login') }}
                        </button>
                    </form>
                    <!--------------Google data------------>

                    <div class="google d-flex justify-content-center align-items-center flex-column gap-3 mt-4">
                        <p class="line-after">or continue with</p>
                        <button class="d-flex justify-content-center align-items-center gap-2">
                            <img src="../../assets/images/home/google.png">
                            <span>Login in with google </span>
                        </button>
                    </div>

                    <!------------------->
                    <p class="text-center text-18 pt-15">
                        {{ $t('auth.noAccountMessage') }} ?
                        <router-link to="/signup" class="fw-700 signup-button"> {{ $t('auth.signUpLink')
                            }}</router-link>
                    </p>
                    <!----------------->
                </div>
            </div>
        </div>
    </section>
    <!-- Modal --
    <div class="modal fade" id="termsandconditions" tabindex="-1" aria-labelledby="termsandconditionsLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="termsandconditionsLabel"> {{ $t('terms_conditions') }} </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <TermsContent :signUp="true" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal">إغلاق</button>
                </div>
            </div>
        </div>
    </div>-->
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import TelInput from '../common/TelInput';
import { userLogin } from '@/Services/api/AuthService';

export default {
    components: { TelInput },
    data() {
        return {
            userEmail: '',
            confirmPass: '',
            password: '',
            showPasswordValue: true,
            formSubmitted: false,
            serverError: ""
        }
    },
    setup() {
        return { v$: useVuelidate() }
    },
    validations() {
        return {
            userEmail: { required: helpers.withMessage(() => this.$t('validations.required'), required) },
            password: { required: helpers.withMessage(() => this.$t('validations.required'), required) },
        }
    },
    methods: {
        //Submit Sign up Form
        async submitLogin() {
            this.v$.$validate();
            this.formSubmitted = true;

            if (!this.v$.$error) {
                const formData = {
                    login: this.userEmail,
                    password: this.password,
                }
                // this.$store.dispatch('updateUserEmail', this.userEmail)
                try {
                    // Call the userRegister service
                    const response = await userLogin(formData);
                    // Handle successful registration
                    if (!response.success) {
                        this.serverError = "";
                        this.$store.commit('setUserData', response.data.data);
                        this.$store.commit("setAccessToken", response.data.data.token);
                        this.$store.commit("setAuthenticated", true),
                            this.$router.push('/');
                    }
                } catch (error) {
                    this.serverError = error.message;
                }
            }
        },
        hidePassword() {
            this.showPasswordValue = false;
        },
        showPassword() {
            this.showPasswordValue = true;
        },
    },

}
</script>
<style lang="scss" scoped>
$font-family: Almarai;
$font-weight-normal: 400;
$font-weight-bold: 700;
$color-gray: #c7c7c7;
$color-black: #000;
$color-primary: #206387;
$color-facebook: #3D5A98;
$color-linkedin: #0076B2;
$color-email : #263238;
$color-white : rgba(255, 255, 255, 1);

/******************* */
.forget-pass{
    transition: 0.2s ease-in-out;
    color: #4D4D4D;
    &:hover{
        color: #099de7 !important;
    }
}
.line-after {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;
    width: 80%;
}

.line-after::before,
.line-after::after {
    content: "";
    background: #ddd;
    display: block;
    flex-grow: 1;
    height: 1px;
    margin: 0 10px;
}


hr {
    width: 75%;
    background: #ddd;
    height: 0.8px;
    display: block;
    margin: 10px auto;
}

.google {
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 20px;

    button {
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 10px 20px;
    }

    span {
        font-weight: 500;
        color: var(--Dark-blue, #0F1030);
    }

    img {
        width: 30px;
    }
}

* {
    &:lang(en) {
        font-family: "poppins", sans-serif !important;
    }

    &:lang(ar) {
        font-family: "Almarai", serif !important;
    }
}

.form-group {
    margin: 15px 0;
}

input[type=text] {
    border: none !important;

    &:focus {
        border: none !important;
    }
}

/*********************/
.image {
    background-image: url("../../assets/images/home/Hero.svg");
    //background-image: url("../../assets/images/home/sign-up.png");
    background-position: center center;
    background-size: cover;
    height: 100%;
}

a {
    cursor: pointer;
}

.content-login {
    .info {
        display: flex;
        align-items: flex-start;
        flex-direction: column;

        h3,
        p {
            color: var(--Dark-blue, #0F1030);
        }

        h3 {
            margin-top: 60px;
            margin-bottom: 12px;
            font-size: 30px;
            font-weight: 500;
        }

        p {
            font-size: 16px;

            span {
                display: inline-block;
                margin-bottom: 8px;
            }
        }
    }
}

input:focus,
input:focus-visible {
    outline: none;
    border: none !important;
}

/**********************************/
.user-first,
.user-last {
    top: 50%;
}

.user-first,
.user-last,
.user-first-2 {
    position: absolute;
    transform: translateY(-50%);

    &:lang(ar) {
        right: 0px;
    }

    &:lang(en) {
        left: 0px;
    }
}

.user-first-2 {
    top: 57%;
}

/********************************/

input[type="text"],
input[type="password"] {
    font-size: 18px;

    &:lang(ar) {
        padding: 5px 20px 0 0;
        text-align: right;
    }

    &:lang(en) {
        padding: 5px 0 0 20px;
        text-align: left;
    }

    border:none;
    background: #f8f9fa;

    &::placeholder {
        color: #0F1030;
        font-size: 12px;
        font-weight: $font-weight-normal;
        padding: 0px 5px;
    }
}

input[type="password"] {
    padding: 5px 35px 5px 35px;
}

input[type="text"] {
    width: inherit;
}

.phone-container {
    border: 1px solid #E0E0E0;
}

.label-link {
    color: #0076B2;
    font-size: 14px;
}

/*************New Edits**************************************/
.form-control:focus-within {
    border-color: #206387;

    ::placeholder {
        opacity: 0;
    }
}

.mb-24 {
    margin-bottom: 34px;
}

.form-control {
    border: none !important;
    border-bottom: 1px solid #0F1030 !important;
    border-radius: 0 !important;

    &:lang(en) {
        padding-left: 0 !important;
    }

    &:lang(ar) {
        padding-right: 0 !important;
    }
}

input {
    border: none !important;
}

.input-group-text-fa {
    position: absolute;
    top: 11px;
    display: inline-flex;
    align-items: center;
    padding: 0.375rem 0.75rem;
    font-weight: 400;
    line-height: 1.5;

    &:lang(ar) {
        left: 0;
    }

    &:lang(en) {
        right: 0;
    }

    .fa {
        color: #a6a6a6;
        font-size: 16px;
    }
}

.form-check-input:checked,
.form-check-input[type=checkbox]:indeterminate {
    background-color: $color-facebook;
    border-color: $color-facebook;
}



button[type="submit"] {
    font-size: 20px;
    font-weight: $font-weight-bold;
    margin-top: 35px;
}

.signIn {
    gap: 5px;

    span {
        color: $color-black;
        font-weight: $font-weight-normal;
        font-size: 14px;
    }

    a {
        font-weight: $font-weight-normal;
        font-size: 14px;
        color: #2ea2ce;
    }
}

@media screen and (max-width: 992px) {
    .image {
        display: none;
    }
}
</style>